export interface ISuperficie {
  idSuperficie?: number;
  codigo: string;
  codigoInterno?: string;
  descricao: string;
  idSituacao: number;
  idStatus: number;
  idReferencia?: number;
  idLinha?: number;
  // FASE 05 — 4ª validação/Frente 9 2026-07-30: "Categoria" (lista fixa) virou "Grupo",
  // selecionado direto do Cadastro de Grupos (idGrupo); a regra dinâmica do formulário
  // passa a olhar a DESCRIÇÃO do grupo selecionado.
  idGrupo?: number; // Obrigatório — IdGrupo/IdGrupoMaterial no backend
  idCor?: number;
  idUnidadeValorizacao: number; // IdUnidadeItemEmbalagem no backend
  precoVariavel?: boolean; // R$ variável - apenas quando Un. Valorização = M²

  // Campos condicionais - Grupo TELA RETRÁTIL
  idTipoTecido?: number;
  idCorTecido?: number; // Cor do tecido (grupo TELA RETRÁTIL)
  acionamento?: string; // legado (texto); substituído por `voltagem`
  voltagem?: number; // FASE 05 — 6ª val. 2026-08-06: 110V=1 | 220V=2 | bivolt=3 (coluna numérica Voltagem)
  larguraMinima?: number;
  larguraMaxima?: number;
  alturaMinima?: number;
  alturaMaxima?: number;

  // Campos condicionais - Grupo ESTEIRA MONTADA
  peso?: number;
  passo?: string;
  terminal?: string; // 'Sim' | 'Não' (o backend converte p/ BIT)
  
  // Outros campos
  ipi?: number;
  idImportacaoMaterial?: number;
  
  imagemUrl?: string;
  imagemNomeArquivo?: string;
  
  dataUltimaAtualizacao?: string;
  dataCriacao?: string;
  editavel?: boolean;
  excluido?: boolean;
}

export interface ISelectOption {
  id: number;
  nome: string;
  descricao?: string;
}

// FASE 05 — 4ª validação/Frente 9 2026-07-30: aba "Dimensões" removida (relatório do PO).
export type SuperficieTabIndex = 0;
export const SUPERFICIE_TABS = ['GERAL'] as const;

// FASE 05 — 4ª validação/D3 2026-07-30: semântica legada — 3 = Disponível mercado,
// 4 = Indisponível (fora do fluxo), 5 = Homologado (estado novo do fluxo).
export const SITUACAO_OPTIONS = [
  { id: 1, label: 'Em edição' },
  { id: 2, label: 'Em homologação' },
  { id: 3, label: 'Disponível mercado' },
  { id: 4, label: 'Indisponível' },
  { id: 5, label: 'Homologado' },
];

export const STATUS_OPTIONS = [
  { id: 1, label: 'Ativo' },
  { id: 2, label: 'Descontinuado' },
  // FASE 05 — 2ª validação/PO 2026-07-24 (Frente 7, P5): "Inativo" removido do front.
];

// FASE 05 — 4ª validação/Frente 9 2026-07-30: a lista fixa de categorias saiu — o Grupo vem do
// Cadastro de Grupos (/ReferenciaDados/Grupos?tipoMaterial=superficies). Os campos condicionais
// são decididos pela descrição do grupo selecionado (comparação case-insensitive).
export const GRUPO_TELA_RETRATIL = 'TELA RETRÁTIL';
export const GRUPO_ESTEIRA_MONTADA = 'ESTEIRA';

export const grupoTemDescricao = (
  grupos: ISelectOption[],
  idGrupo: number | undefined,
  descricaoEsperada: string
): boolean => {
  if (!idGrupo) return false;
  const grupo = grupos.find((g) => g.id === idGrupo);
  if (!grupo) return false;
  const descricao = (grupo.nome || grupo.descricao || '').trim().toUpperCase();
  return descricao === descricaoEsperada.toUpperCase();
};

// FASE 05 — 6ª validação/PO 2026-08-06: Voltagem grava na coluna numérica Voltagem (110V=1/220V=2/bivolt=3).
export const VOLTAGEM_OPTIONS = [
  { id: 1, label: '110V' },
  { id: 2, label: '220V' },
  { id: 3, label: 'bivolt' },
];

// FASE 05 — 6ª validação/PO 2026-08-06: Terminal grava "Sim"/"Não"; o backend converte p/ BIT.
export const TERMINAL_OPTIONS = [
  { id: 'Sim', label: 'Sim' },
  { id: 'Não', label: 'Não' },
];
